import React from "react";
import { CircularProgress, Backdrop } from "@mui/material";

interface FullScreenLoadingProps {
  loading?: boolean;
}

const FullScreenLoading: React.FC<FullScreenLoadingProps> = ({ loading }) => {
  return (
    <Backdrop
      sx={{
        color: "primary.main",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: "flex",
        flexDirection: "column",
      }}
      open={loading ?? true}
    >
      <CircularProgress color="inherit" size={100} />
    </Backdrop>
  );
};

export default FullScreenLoading;
